module.exports = __webpack_public_path__ + "06_mole.f756f2b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer2/06_mole.png
// module id = J1J/
// module chunks = 0